import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45authenticated_45global from "/app/middleware/00-authenticated.global.ts";
import page_45title_45global from "/app/middleware/page-title.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45authenticated_45global,
  page_45title_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}